import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100;
  padding: ${({ theme }) => theme.spacing(4)};
  background: rgb(0 0 0 / 55%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Dialog = styled.div`
  width: min(520px, 100%);
  padding: ${({ theme }) => theme.spacing(6)};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.dark.large};
`;

export const Title = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

export const Message = styled.div`
  color: ${({ theme }) => theme.colors.mediumGray};
  line-height: 1.5;
`;

export const Actions = styled.div`
  margin-top: ${({ theme }) => theme.spacing(6)};
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(3)};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column-reverse;
  }
`;

const ActionButton = styled.button`
  min-height: 44px;
  padding: 0 ${({ theme }) => theme.spacing(4)};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 3px;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }
`;

export const CancelButton = styled(ActionButton)`
  border: 1px solid ${({ theme }) => theme.colors.gray};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.mediumGray};
`;

export const ConfirmButton = styled(ActionButton)`
  border: 1px solid ${({ theme }) => theme.colors.red};
  background: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
`;
